import { gql } from '@apollo/client'

export interface MutationVars {
  flagId: string
  customerId: string
  payload: FlagFeedbackPayload
}

export interface FlagFeedbackPayload {
  serviceName: string
  helpful: boolean
  comment?: string
  userId: string
  subjectId: string
}

export type Response = string

const mutation = gql`
  mutation patchFlagFeedback(
    $customerId: String!
    $flagId: String!
    $payload: PatchFlagFeedbackInput!
  ) {
    patchFlagFeedback(customerId: $customerId, flagId: $flagId, payload: $payload)
  }
`

export default mutation
